import { useEffect, useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PlanFormModal from '../home/components/PlanFormModal';
import DentalSEO from './components/DentalSEO';
import DentalHero from './components/DentalHero';
import DentalValue from './components/DentalValue';
import DentalScreens from './components/DentalScreens';
import DentalPricing from './components/DentalPricing';
import DentalCompare from './components/DentalCompare';
import DentalFlow from './components/DentalFlow';
import DentalFAQ from './components/DentalFAQ';
import DentalCTA from './components/DentalCTA';
import { useDentalCurrency } from './useDentalCurrency';
import type { DentalPlan } from '../../mocks/dental';
import './dental.css';

const WHATSAPP_ADVISOR =
  'https://wa.me/18495388899?text=Hola%20InnoFlex!%20Quiero%20hablar%20con%20un%20asesor%20sobre%20InnoFlex%20Odontolog%C3%ADa%20Premium.';

const DEMO_ACCENT = '#06b6d4';

export default function DentalPage() {
  const { currency, setCurrency } = useDentalCurrency();
  const [formPlan, setFormPlan] = useState<{ name: string; color: string } | null>(null);

  /* Si se llega con un ancla (p. ej. desde las tarjetas de industrias),
     se baja a esa sección; si no, la página abre desde arriba. */
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (!hash) {
      window.scrollTo({ top: 0 });
      return;
    }
    const timer = setTimeout(() => {
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollTo({ top: 0 });
    }, 120);
    return () => clearTimeout(timer);
  }, []);

  /* El botón de demostración reutiliza el formulario de contacto existente
     (PlanFormModal), el mismo que usan los planes generales. */
  const requestDemo = () =>
    setFormPlan({ name: 'InnoFlex Odontología — Demostración', color: DEMO_ACCENT });

  const handleSelectPlan = (plan: DentalPlan) => {
    if (plan.ctaKind === 'advisor') {
      window.open(WHATSAPP_ADVISOR, '_blank', 'noopener,noreferrer');
      return;
    }
    setFormPlan({ name: `InnoFlex Odontología ${plan.name}`, color: plan.accent });
  };

  return (
    <div className="dental-page min-h-screen flex flex-col overflow-x-hidden">
      <DentalSEO />
      <Navbar />
      <main className="flex-1">
        <DentalHero onRequestDemo={requestDemo} />
        <DentalValue />
        <DentalScreens />
        <DentalPricing
          currency={currency}
          onCurrencyChange={setCurrency}
          onSelectPlan={handleSelectPlan}
        />
        <DentalCompare currency={currency} />
        <DentalFlow />
        <DentalFAQ />
        <DentalCTA onRequestDemo={requestDemo} />
      </main>
      <Footer />

      {formPlan && (
        <PlanFormModal
          planName={formPlan.name}
          planColor={formPlan.color}
          onClose={() => setFormPlan(null)}
        />
      )}
    </div>
  );
}
